module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#album",
      toString: function () {
        return this.url;
      }
    }